export default {
  title: '创建拓店任务', // 拓店标准版-门店管理
  url: '/expandstore/expansiontask/edit' // 埋点用，记录所属模块
};
